import { ReactNode } from 'react';

import { Text } from '@mantine/core';

/** Подпись внутри поля; в компактном варианте мельче */
export const FieldCaption = ({ children, compact }: { children: ReactNode; compact?: boolean }) => (
	<Text c="#667085" fz={compact ? 10 : 12} fw={500} lh="normal" tt="uppercase">
		{children}
	</Text>
);
